import { IconButton } from "@mui/material";
import { RemoveCircle, DownloadForOffline } from "@mui/icons-material";
import FileUploader from "@components/ui/FileUploader/FileUploader"
import "./AdjuntosPartesContainer.scss"
import { convertToBase64FromFileInput } from "@helpers/utils";
import { FilePedido } from "@components/FormParte/FormPedido";

const AttachedFiles = ({ files = [], handleRemove = () => { }, handleDownload = () => { }, editable = false, isView = false }: any) => {
  const renderDeleteFileButton = editable
  const renderDownloadFileButton = isView

  return (
    <ul className="attached-files-wrapper">
      {files.map((file: any, index: any) => (
        <li key={index} className="attached-file">
          <span>{file.name}</span>
          {renderDeleteFileButton && !file.unique_id && (
            <IconButton
              onClick={() => handleRemove(index)}
            >
              <RemoveCircle sx={{ color: "#CD5C5C" }} />
            </IconButton>
          )}
          {(renderDownloadFileButton || file.unique_id) && (
            <IconButton
              onClick={() => handleDownload(file)}
            >
              <DownloadForOffline sx={{ color: "#075577" }} />
            </IconButton>
          )}
        </li>
      ))}
    </ul>
  )
}

const AdjuntosPartesContainer = ({ files = [], setFiles, editable, isView }: any) => {
  const handleAddFile = async (event: any) => {
    const file = event.target.files[0]
    if (!file) return

    if (file.size > 200000000) { // 200MB
      alert("No se pueden insertar archivos de más de 200MB.")
      return
    }

    const fileInBase64 = await convertToBase64FromFileInput(file, true)
    if (!fileInBase64) return

    const fileToInsert = {
      name: file.name,
      base64: fileInBase64,
    }
    setFiles([...files, fileToInsert])
  }

  const handleRemoveFile = (indexToRemove: any) => {
    const newFiles = files.filter((_: any, index: any) => index !== indexToRemove)
    setFiles(newFiles)
  }

  const handleDownload = async (file: FilePedido) => {
    if (!file.base64 || !file.name) {
      alert("No se puede descargar este archivo.")
      return
    }

    try {
      // Mapea las extensiones conocidas a sus MIME types
      const mimeTypes = {
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        txt: 'text/plain',
        csv: 'text/csv',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        default: 'application/octet-stream',
      };

      type MimeTypeKey = keyof typeof mimeTypes;

      const extension = (file.name.split('.').pop()?.toLowerCase() || 'default') as MimeTypeKey;
      const mimeType = mimeTypes[extension] || mimeTypes.default;

      // Elimina el encabezado si existe
      const base64Data = file.base64.replace(/^data:.*;base64,/, '');

      // Convierte el base64 a un blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });

      const urlBlob = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = urlBlob
      a.download = file.name
      a.click()
      window.URL.revokeObjectURL(urlBlob)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="adjuntos-wrapper">
      <h5 className="text-center header-add">Archivos adjuntos del parte</h5>
      {files && files.length > 0 ? (
        <AttachedFiles
          files={files}
          handleRemove={handleRemoveFile}
          handleDownload={handleDownload}
          editable={editable}
          isView={isView}
        />
      ) : (
        <span>No hay archivos en el parte.</span>
      )}
      {editable && (
        <FileUploader
          labelText="Seleccionar archivo"
          onFileSelect={handleAddFile}
        />
      )}
    </div>
  )
}

export default AdjuntosPartesContainer